import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useStateContext } from '../Contexts/ContextProvider';
import styles from './Login.module.css';
import logo from "./Alayaa.png";

const Logout = () => {
  const { setToken } = useStateContext();

  useEffect(() => {
    localStorage.removeItem('ACCESS_TOKEN');
    setToken(null);
  }, [setToken]);

  return (
    <div className={`${styles.loginContainer} d-flex align-items-center justify-content-center min-vh-100`}>
      <div className="col-lg-5 col-md-8 col-12">
        <div className={`${styles.card} card shadow-lg border-0 text-center`}>
          <div className="card-body p-5">
            <div className="mb-4">
              <i className="fas fa-check-circle text-success display-1"></i>
            </div>
            <h2 className="fw-bold mb-3">Goodbye!</h2>
            <p className="text-muted mb-4">You have been successfully logged out.</p>
            <Link to="/" className={`${styles.submitBtn} btn w-50`}>
              <i className="fas fa-sign-in-alt me-2"></i> Log In Again
            </Link>
          </div>
          <div className="card-footer text-center border-0 bg-transparent pb-4">
            <p className="text-muted small mb-0">
              Al-Alia · Conference Attendance Management
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Logout;